import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import UserService from "../../services/users";
export default function Signature(props) {

    const [step, setStep] = useState(0);
    const [email, setEmail] = useState('');
    const [securityCode, setSecurityCode] = useState('');
    const [password, setPassword] = useState('');

    let handleClose = () => {
        props.handleClose();
    }

    let sendSecurityCode = () => {
        UserService.sendSecurityCode(email).then(
            (result)=>{
                props.handleMessage({title:'Wijzigingscode is verstuurd. Mocht u de mail niet kunnen vinden, controleer dan uw JUNK/SPAM folder'})
            
            },(error)=>{
                props.handleMessage({title:'De wijzigingscode kan niet worden verstuurd, neem contact op met ARAL Lasservice'})
            }
        )
        setStep(1);
    }

    let savePassword = () => {
        UserService.setNewPassword(email,securityCode,password).then(
            (result)=>{
                props.handleMessage({title:'U kunt nu inloggen met uw E-mailadres en nieuw wachtwoord'})
                props.handleClose();
            },(error)=>{
                props.handleMessage({title:'Het wijzigen is mislukt, controleer uw wijzigingscode'})
            }
        )
      
    }

    return (
        <div>
            <Dialog
                fullScreen
                open={true}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Aanmaken (nieuw) wachtwoord</DialogTitle>
                <DialogContent style={{ minWidth: '400px' }}>
                    <DialogContentText>
                        Vul hieronder uw E-mailadres is. Indien deze in ons systeem bekend is ontvangt u een wijzigingscode om uw (nieuwe) wachtwoord aan te maken.
                    </DialogContentText>
                    <TextField label='E-mailadres' style={{ width: '100%', backgroundColor: 'white' }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <br /><br />
                    <Button style={{ width: '100%' }} variant="contained" color="primary" onClick={() => sendSecurityCode()}>
                        Verstuur wijzigingscode
                    </Button>
                    <br /><br />
                    {step === 1 &&
                        <React.Fragment>
                            <TextField label='Vul hier de wijzigingscode in die u per mail hebt ontvangen' style={{ width: '100%', backgroundColor: 'white' }}
                                value={securityCode}
                                onChange={(e) => setSecurityCode(e.target.value)}
                            />
                            <br /><br />
                            <TextField label='Uw nieuw wachtwoord' style={{ width: '100%', backgroundColor: 'white' }}
                                value={password} type="password"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <br /><br />
                            <Button style={{ width: '100%' }} variant="contained" color="primary" onClick={() => savePassword()}>
                                Opslaan nieuw wachtwoord
                    </Button>

                        </React.Fragment>
                    }

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">Sluiten</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
